(function() {
  'use strict';

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var resizeTimer = null;

  function init() {
    var sections = document.querySelectorAll('.wb-collection');
    sections.forEach(function(section) {
      setupSort(section);
      setupFilters(section);
      setupQuickAdd(section);
      setupLoadMore(section);
    });
  }

  function setupSort(section) {
    var select = section.querySelector('[data-wbc-sort-select]');
    if (!select) return;

    select.addEventListener('change', function() {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  function setupFilters(section) {
    var toggleBtn = section.querySelector('[data-wbc-filter-toggle]');
    var drawer = section.querySelector('[data-wbc-filter-drawer]');
    var closeBtns = section.querySelectorAll('[data-wbc-filter-close]');
    var filterInputs = section.querySelectorAll('[data-wbc-filter-input]');
    var applyBtns = section.querySelectorAll('[data-wbc-filter-apply]');

    if (!drawer) return;

    function openDrawer() {
      drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    if (toggleBtn) {
      toggleBtn.addEventListener('click', openDrawer);
    }

    closeBtns.forEach(function(btn) {
      btn.addEventListener('click', closeDrawer);
    });

    function applyFilters() {
      var collectionUrl = section.getAttribute('data-collection-url') || window.location.pathname;
      var url = new URL(collectionUrl, window.location.origin);

      var currentUrl = new URL(window.location.href);
      var sortBy = currentUrl.searchParams.get('sort_by');
      if (sortBy) {
        url.searchParams.set('sort_by', sortBy);
      }

      filterInputs.forEach(function(input) {
        if (input.type === 'checkbox') {
          if (input.checked) {
            url.searchParams.append(input.name, input.value);
          }
        } else if (input.type === 'number') {
          if (input.value && input.value.trim() !== '') {
            url.searchParams.set(input.name, input.value);
          }
        }
      });

      window.location.href = url.toString();
    }

    filterInputs.forEach(function(input) {
      if (input.type === 'checkbox') {
        input.addEventListener('change', function() {
          applyFilters();
        });
      }
    });

    applyBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        applyFilters();
      });
    });
  }

  function setupQuickAdd(section) {
    var quickBtns = section.querySelectorAll('[data-wbc-quick-add]');

    quickBtns.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        if (btn.disabled || btn.classList.contains('is-loading')) return;

        var variantId = btn.getAttribute('data-wbc-quick-add');
        if (!variantId) return;

        btn.classList.add('is-loading');
        var originalText = btn.textContent;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: parseInt(variantId, 10),
            quantity: 1
          })
        })
        .then(function(response) {
          if (!response.ok) throw new Error('Add to cart failed');
          return response.json();
        })
        .then(function() {
          btn.classList.remove('is-loading');
          btn.textContent = '✓';
          setTimeout(function() {
            btn.textContent = originalText;
          }, 1200);
        })
        .catch(function() {
          btn.classList.remove('is-loading');
          btn.textContent = originalText;
        });
      });
    });
  }

  function setupLoadMore(section) {
    var loadMoreBtn = section.querySelector('[data-wbc-load-more]');
    if (!loadMoreBtn) return;

    loadMoreBtn.addEventListener('click', function() {
      var nextUrl = loadMoreBtn.getAttribute('data-next-url');
      if (!nextUrl || loadMoreBtn.classList.contains('is-loading')) return;

      loadMoreBtn.classList.add('is-loading');

      fetch(nextUrl)
        .then(function(response) {
          return response.text();
        })
        .then(function(html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('[data-wbc-grid]');
          var newPagination = doc.querySelector('[data-wbc-pagination]');
          var grid = section.querySelector('[data-wbc-grid]');
          var pagination = section.querySelector('[data-wbc-pagination]');

          if (newGrid && grid) {
            var newCards = newGrid.querySelectorAll('[data-wbc-card]');
            newCards.forEach(function(card) {
              grid.appendChild(card);
            });

            setupQuickAdd(section);
          }

          if (pagination && newPagination) {
            pagination.innerHTML = newPagination.innerHTML;
            setupLoadMore(section);
          } else if (pagination) {
            pagination.remove();
          }

          var countEl = section.querySelector('.wb-collection__count');
          var newCount = doc.querySelector('.wb-collection__count');
          if (countEl && newCount) {
            countEl.textContent = newCount.textContent;
          }
        })
        .catch(function() {
          loadMoreBtn.classList.remove('is-loading');
        });
    });
  }

  document.addEventListener('shopify:section:load', function(e) {
    var section = e.target.querySelector('.wb-collection');
    if (section) {
      setupSort(section);
      setupFilters(section);
      setupQuickAdd(section);
      setupLoadMore(section);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();